<div class="mat-body-1 instruction instruction--out-grid">Add an announcement</div>
<div onsip-grid-placement-shelf>
  <div class="first-column instruction-container">
    <div class="instruction">
      To create a custom announcement: Click the microphone to start recording your voice. After you
      finish recording, you can review the announcement.
    </div>
    <div class="instruction">To upload an announcement: Upload a pre-recorded wav file.</div>
  </div>
  <div class="second-column">
    <onsip-loading-container
      [deferCond]="loadingStateComplete$"
      [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
    >
      <form [formGroup]="recordingEditInfo" class="recording-edit-form">
        <onsip-togglable-recorder
          [hasSave]="true"
          (saved)="submit()"
          entityLabel="recording"
          formControlName="record"
        >
        </onsip-togglable-recorder>
      </form>
    </onsip-loading-container>
  </div>
</div>
<div class="page-view-controls">
  <button mat-button class="cancel-button" color="primary" type="button" (click)="togglePanel()">
    {{ "ONSIP_I18N.CANCEL" | translate }}
  </button>
</div>
